import { create } from "zustand";
import { HistoryFilterActions, HistoryFilterState } from "./types";
import { InteractionHistoryFilter } from "@/components/organisms/history/types";
import { getInitialHistoryFilterData } from "@/common/helpers/historyHelper";

export const useHistoryFilterStore = create<
HistoryFilterState & HistoryFilterActions
>((set) => ({
    filterData: getInitialHistoryFilterData(),
    queueIds: [],
    setFilterData: (filterData: InteractionHistoryFilter) =>
        set((state: HistoryFilterState) => ({ ...state, filterData })),
    setQueueIds: (queueIds: string[]) =>
        set((state: HistoryFilterState) => ({ ...state, queueIds }))
}));